<header id="header" class="fixed-top d-flex align-items-center">
    <drme-toolbar class="w-100"></drme-toolbar>
</header>


<router-outlet></router-outlet>
<footer id="footer">
    <drme-footer class="w-100"></drme-footer>
</footer>
